import { InjectionToken } from '@angular/core';
import { HasuraBaseQuery, HasuraQuery } from '@anduin/shared';

export const FAILED_HASURA_BASE_QUERY_TOKEN = new InjectionToken<HasuraBaseQuery>('FAILED_HASURA_BASE_QUERY_TOKEN');

export const FAILED_HASURA_BASE_QUERY = new HasuraBaseQuery(
  'getUnsentEmailsFailed',
  'vw_unsent_email_failed',
  [
    new HasuraQuery('id'),
    new HasuraQuery('status'),
    new HasuraQuery('reason_code', null, null, 'reasonCode'),
    new HasuraQuery('created_at', null, null, 'createdAt'),
    new HasuraQuery('updated_at', null, null, 'updatedAt'),
    new HasuraQuery('dismissed_at', null, null, 'dismissedAt'),
    new HasuraQuery('resolved_at', null, null, 'resolvedAt'),
    new HasuraQuery('retrying_since', null, null, 'retryingSince'),
    new HasuraQuery('resolved_outbound_email_v4_id', null, null, 'resolvedOutboundEmailV4Id'),
    new HasuraQuery('resolved_by_staff_id', null, null, 'resolvedByStaffId'),
    new HasuraQuery('subject'),
    new HasuraQuery('invoice_number', null, null, 'invoiceNumber'),
    new HasuraQuery('recipient_email', null, null, 'recipient'),
    new HasuraQuery('recipient_cc', null, null, 'recipientCc'),
    new HasuraQuery('recipient_bcc', null, null, 'recipientBcc'),
    new HasuraQuery('all_recipients', null, null, 'allRecipients'),
  ],
);
